class DateFormElementController {
  constructor() {

  }

  $onInit() {
    if(this.value === parseInt(this.value)){
      // its an int (timestamp)
      this.value = new Date(this.value * 1000);
    }
    else{
      // its a string
      this.value = new Date(this.value);
    }
  }
}

export default DateFormElementController;
